import React from 'react';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import FeatherIcon from 'feather-icons-react';
import { whyChooseUsData } from '../../data';
import { whyChooseUsDataArabic } from '../../data/indexArabic';
import { useAuth } from '../../store/auth';

const WhyChooseUsSection = () => {
  const { isArabic } = useAuth();
  const data = isArabic ? whyChooseUsData : whyChooseUsDataArabic;

  return (
    <React.Fragment>
      {data && (
        <Container>
          <Row className="align-items-center">
            <Col lg="6" md="6" xs="12">
              <div className="section-title me-lg-4">
                <span className="badge rounded-pill bg-soft-primary">{data?.badgeText}</span>
                <h4 className="title mt-3 mb-4">
                  {data?.titles?.map((ele, index) => (
                    <span key={index} className={ele.highlight ? 'text-primary' : ''}>
                      {ele.breakPoint && <br />}
                      {ele.title}
                    </span>
                  ))}
                </h4>
                <p className="text-muted para-desc mb-4">
                  {data?.description?.map((ele, index) => (
                    <span className={ele.highlight ? 'text-primary fw-bold' : ''} key={index}>
                      {ele.content}
                    </span>
                  ))}
                </p>

                {/* Key Points List */}
                <div className="mt-4">
                  {data?.keyPoints?.map((point, key) => (
                    <div key={key} className="d-flex align-items-start mb-3">
                      <div className="flex-shrink-0">
                        <div className="avatar avatar-ex-sm rounded-circle bg-soft-primary d-flex align-items-center justify-content-center me-3">
                          <FeatherIcon icon="check" className="text-primary" size={16} />
                        </div>
                      </div>
                      <div className="flex-grow-1">
                        <h6 className="mb-1">{point.title}</h6>
                        <p className="text-muted mb-0 small">{point.description}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </Col>

            <Col lg="6" md="6" xs="12" className="mt-4 mt-sm-0 pt-2 pt-sm-0">
              <Row>
                {data?.features?.map((feature, key) => (
                  <Col key={key} xs="12" className={key > 0 ? "mt-4" : ""}>
                    <Card className="features feature-primary border-0 rounded-3 shadow-sm p-4">
                      <div className="d-flex align-items-center">
                        <div className="flex-shrink-0">
                          <div className="icon d-flex align-items-center justify-content-center bg-soft-primary rounded-circle me-4" style={{ width: '60px', height: '60px' }}>
                            <FeatherIcon icon={feature.icon} className="text-primary" size={24} />
                          </div>
                        </div>
                        <div className="flex-grow-1">
                          <CardBody className="p-0">
                            <h5 className="title mb-2">{feature.title}</h5>
                            <p className="text-muted mb-0">{feature.description}</p>
                          </CardBody>
                        </div>
                      </div>
                    </Card>
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>
        </Container>
      )}
    </React.Fragment>
  );
};

export default WhyChooseUsSection;
